module.exports = __webpack_public_path__ + "img/20044.8d6abffd.png";